/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentDataset } from './ConversationalAgentDataset';
import {
  ConversationalAgentDatasetFromJSON,
  ConversationalAgentDatasetFromJSONTyped,
  ConversationalAgentDatasetToJSON,
} from './ConversationalAgentDataset';

/**
 *
 * @export
 * @interface PaginatedConversationalAgentDatasetList
 */
export interface PaginatedConversationalAgentDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedConversationalAgentDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ConversationalAgentDataset>}
   * @memberof PaginatedConversationalAgentDatasetList
   */
  results: Array<ConversationalAgentDataset>;
}

/**
 * Check if a given object implements the PaginatedConversationalAgentDatasetList interface.
 */
export function instanceOfPaginatedConversationalAgentDatasetList(
  value: object,
): value is PaginatedConversationalAgentDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedConversationalAgentDatasetListFromJSON(json: any): PaginatedConversationalAgentDatasetList {
  return PaginatedConversationalAgentDatasetListFromJSONTyped(json, false);
}

export function PaginatedConversationalAgentDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedConversationalAgentDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ConversationalAgentDatasetFromJSON),
  };
}

export function PaginatedConversationalAgentDatasetListToJSON(
  value?: PaginatedConversationalAgentDatasetList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ConversationalAgentDatasetToJSON),
  };
}
